module.exports = {template: '<svg viewBox="0 0 58.37132 89.01192"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="4" d="M29.186 0v84.375"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="3" d="M57.311 58.766L29.186 86.891 1.061 58.766"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/slider-arrow.svg
// module id = 183
// module chunks = 1